import { IS_BROWSER } from '~/app/constants'

export const applyServiceHeaders = (config: Gallery.Config.IServiceConfig): Gallery.Config.IServiceConfig => {
  // No need to modify headers in the browser environment
  if (IS_BROWSER) {
    return config
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      'Accept-Encoding': 'br, gzip, deflate',
    },
  }
}
